import React from 'react';
import { Icon } from 'components';
import { Typography } from 'e100-react-components';
import { useStyles } from './style';

interface BestPriceIconProps {
  label: string;
}

export const BestPriceIcon = ({ label = '' }: BestPriceIconProps) => {
  const classes = useStyles();

  return (
    <Typography
      variant="caption"
      classes={{
        root: classes.text,
      }}
    >
      <Icon
        kind={'star'}
        classes={{
          root: classes.icon,
        }}
      />
      <span
        className={classes.label}
        dangerouslySetInnerHTML={{ __html: label }}
      />
    </Typography>
  );
};
